import { ctrlCmdModule } from "@/store/modules/control-commands.module";
import { CTRL_COMMAND } from "@/types/socket";
import Vue, { Ref } from "vue";
import Component from "vue-class-component";

@Component({})

export default class HyroxComponent extends Vue {

    created() {
        window.addEventListener('message', this.iframeListener)
        ctrlCmdModule.triggerCtrlCmd({
            trigger: CTRL_COMMAND.HYROX_START,
            value: { id:'hyrox-start' }
        })
    }

    iframeListener(e: MessageEvent) {
        if (e.data) {
            ctrlCmdModule.triggerCtrlCmd({
                trigger: CTRL_COMMAND.HYROX_MESSAGE,
                value: e.data
            })
        }
    }

    destroyed(): void {
        window.removeEventListener('message', this.iframeListener)
        ctrlCmdModule.triggerCtrlCmd({
            trigger: CTRL_COMMAND.HYROX_STOP,
            value: { id: 'hyrox-stop' }
        })
    }
}